import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBell,
  faMessage,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import oneboy from "../Assets/oneboy.png";
import twoboy from "../Assets/twoboy.png";

const Hero = () => {
  return (
    <div className="bg-gradient-to-br from-gray-900 to-black text-white p-8 min-h-screen">
      <main className="flex flex-col-reverse lg:flex-row items-center">
        <div className="w-full lg:w-1/2 px-4 lg:pl-16 lg:pr-12 text-center lg:text-left">
          <h2 className="text-3xl xl:text-6xl lg:text-5xl font-bold mb-6 lg:leading-tight">
            Future Techies are in{" "}
            <span className="bg-gradient-to-r from-green-400 to-blue-500 text-transparent bg-clip-text">
              Metaverse Association.
            </span>
          </h2>
          <p className="mb-8 xl:mb-14 text-gray-400 text-lg"></p>
          <div className="flex justify-center lg:justify-start space-x-4 mb-12">
            <Link to="/about" className="bg-gradient-to-r from-green-400 to-blue-500 text-black px-4 lg:px-6 xl:px-10 py-2 lg:py-3 xl:py-5 rounded-full font-bold flex items-center text-sm lg:text-base xl:text-xl">
              Explore
              <FontAwesomeIcon icon={faChevronRight} className="ml-2" />
            </Link>

            <Link
              to="/members"
              className="border border-gray-600 px-4 lg:px-6 py-2 lg:py-3 rounded-full font-bold text-sm xl:text-xl xl:py-5 xl:px-10 hover:bg-white hover:text-black transition-all lg:text-base"
            >
              Members
            </Link>
          </div>
          <div className="flex justify-center lg:justify-start space-x-4 xl:space-x-14 lg:space-x-8">
            <div className="text-center lg:text-left">
              <h3 className="text-2xl lg:text-3xl xl:text-5xl font-bold">
                50+
              </h3>
              <p className="text-gray-400 text-sm xl:text-lg lg:text-base">
                Projects
              </p>
            </div>
            <div className="text-center lg:text-left">
              <h3 className="text-2xl lg:text-3xl xl:text-5xl font-bold">
                20+
              </h3>
              <p className="text-gray-400 text-sm lg:text-base xl:text-lg">
                Events Attended
              </p>
            </div>
            <div className="text-center lg:text-left">
              <h3 className="text-2xl lg:text-3xl xl:text-5xl font-bold">
                20+
              </h3>
              <p className="text-gray-400 text-sm lg:text-base xl:text-lg">
                Members
              </p>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-1/2 flex justify-center mb-8 lg:mb-0">
          <img
            src={oneboy}
            alt="Future Techies"
            className="max-w-full h-[30%] lg:h-[50%] xl:h-[60%]"
          />
        </div>
      </main>
    </div>
  );
};

export default Hero;
